import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BomItem } from '../../../models/bom-item.model';
import { CreateBomItemResponseDto } from '../bom-tree/dtos/create-bom-item-response.dto';
import { CreatedOrder, Order, OrderHeader, OrderItem } from './models/order.dto';

@Injectable({ providedIn: 'root' })
export class OrdersNewProvider {
  constructor(private http: HttpClient) {}

  // empty term — the dropdown just opened (0099): the first ten products in name order,
  // ready to click; a typed term searches the whole catalogue, the first page of matches (0091)
  searchBomItems(search: string): Observable<BomItem[]> {
    const url = `/api/bom/list`;
    const params: { search?: string, type?: string, pageSize?: number } = search === '' ? { type: 'product', pageSize: 10 } : { search };
    return this.http.get<{ items: BomItem[] }>(url, { params }).pipe(map(list => list.items));
  }

  // JIT BOM: a position the catalog does not know yet is created there first
  createBomItem(name: string): Observable<CreateBomItemResponseDto> {
    const url = `/api/bom`;
    return this.http.post<CreateBomItemResponseDto>(url, { name });
  }

  // header-only zlecenie — the items arrive through the item calls (0039)
  createOrder(): Observable<CreatedOrder> {
    const url = `/api/production-orders`;
    return this.http.post<CreatedOrder>(url, { bomItemId: null });
  }

  getOrder(orderId: number): Observable<Order> {
    const url = `/api/production-orders/${orderId}`;
    return this.http.get<Order>(url);
  }

  patchOrder(orderId: number, header: OrderHeader): Observable<void> {
    const url = `/api/production-orders/${orderId}`;
    return this.http.patch<void>(url, header);
  }

  // add namespaced Dtos and match them with backend to make contracts managable at scale?
  // like CreateOrderItem.OrderItemDto or Orders.OrderItemDto etc
  createOrderItem(orderId: number, bomItemId: number): Observable<OrderItem> {
    const url = `/api/production-orders/${orderId}/items`;
    return this.http.post<OrderItem>(url, { bomItemId });
  }

  // client-sourced item (0014): a copy of the position's tree plus the allocation covering `amount` of it
  createOrderItemFromPosition(orderId: number, clientOrderItemId: number, amount: number): Observable<OrderItem> {
    const url = `/api/production-orders/${orderId}/items`;
    return this.http.post<OrderItem>(url, { clientOrderItemId, amount });
  }

  patchOrderItemAmount(orderId: number, orderItemId: number, amount: number): Observable<void> {
    const url = `/api/production-orders/${orderId}/items/${orderItemId}/amount`;
    return this.http.patch<void>(url, { amount });
  }

  // removes a root item with its whole tree; refused while it covers a client position or has reported progress
  deleteOrderItem(orderId: number, orderItemId: number): Observable<void> {
    const url = `/api/production-orders/${orderId}/items/${orderItemId}`;
    return this.http.delete<void>(url);
  }
}
